import { atom, useAtom } from 'jotai'

const isOpenRideOrdersFilter = atom(false)

export const useOpenRideOrdersFilter = () => {
    const [isOpen, setIsOpen] = useAtom(isOpenRideOrdersFilter)

    return { isOpen, setIsOpen }
}
